export default {"src":"/_next/static/media/Sheep.81425508.svg","height":45,"width":45,"blurWidth":0,"blurHeight":0};